﻿(function () {
    'use strict';
    var controllerId = 'logincontroller';

    angular
        .module('app.controllers')
        .controller(controllerId, logincontroller);

    logincontroller.$inject = ['$scope', '$location', 'common', 'datacontext', '$translate', 'tmhDynamicLocale', '$state', '$rootScope', '$timeout', 'ngDialog', 'config', 'geolocationService','$http'];

    function logincontroller($scope, $location, common, datacontext, $translate, tmhDynamicLocale, $state, $rootScope, $timeout, ngDialog, config, geolocationService, $http) {

        var vm = this;
        vm.version = config.version;
        vm.environment = config.environment;
        vm.user = {
            userName: '',
            password: '',
            useRefreshTokens: true,
            culture: common.config.defaultLanguage,
            languageId: null,
            newPassword: '',
            newPasswordConfirm: ''
        };
        vm.login = login;
        vm.changePassword = changePassword;
        vm.backToLogin = backToLogin;
        vm.showLoader = ShowLoader;
        vm.updateCulture = updateCulture;
        vm.languages = [
            { "code": "es-ES", "id": 2, "name": "Español" }
        ];
        vm.keypress = onkeypress;
        vm.UserId = null;
        vm.passwordRecoveryUrl = '';
        vm.setPasswordRecoveryLink = setPasswordRecoveryLink;
        vm.saveRole = saveRole;
        vm.roleSelected = "";
        vm.rolesInfo = [];
        vm.messageNotAuthorized = "El usuario no esta autorizado para ingresar al portal web.";
        vm.createAccount = createAccount;

        init();
        

        function init() {              
            geolocationService.init();
            common.activateController([getCultureByDefault(), setPasswordRecoveryLink()])
                .then(function () { });
            
                if ($location.path().toUpperCase()=='/CHANGEPASSWORD') {
                    common.localStorageService.set('changePassword', false);
                    vm.UserId = common.localStorageService.get('UserId');
                    $('.formlogin').hide();
                    if (common.localStorageService.get('canChangePassword')) {
                        $('#changePasswordForm').show();
                        return;
                    } else {
                        $('#expirationDateForm').show();
                        return;
                    }
                }
        }

        function isCurrentlyLoggedIn() {
            return common.localStorageService.get('authorizationData') != null;
        }

        function getCultureByDefault() {
            //TODO, adecuar funcionalidad de idioma con archivos de recurso en toda la apliacion
            var data = [
                { "code": "es-ES", "id": 2, "name": "Español" }
            ];

            vm.languages = setFlagByLanguage(data);
            vm.user.languageId = recoverLanguageId(data, common.config.defaultLanguage.toUpperCase());
            $translate.use((vm.user.culture).toLowerCase());
            tmhDynamicLocale.set((vm.user.culture).toLowerCase());

            vm.user.culture = vm.languages[0].code;
        }

        function updateCulture() {
            var data = [
                { "code": "es-ES", "id": 2, "name": "Español" }
            ];

            vm.languages = setFlagByLanguage(data);
            vm.user.languageId = recoverLanguageId(data, vm.user.culture);
            $translate.use((vm.user.culture).toLowerCase());
            tmhDynamicLocale.set((vm.user.culture).toLowerCase());
        }

        function login() {
            if (detectIE() == false) {
                $('#splash-page').removeAttr('style');

                var latitude = common.localStorageService.get('latitude');
                var longitude = common.localStorageService.get('longitude');

                // Mostrar loader si usuario y pass no están vacíos
                if (vm.user.userName !== "" && vm.user.password !== "") {
                    $("#divLoader").removeClass("hideLoader");
                    $("#divLoader").addClass("loader");
                }

                // Primero obtener la IP pública
                $http.get('https://api.ipify.org?format=json')
                    .then(function (response) {
                        var ip = response.data.ip;

                        var modelUserLogin = {
                            username: vm.user.userName,
                            password: vm.user.password,
                            latitude: latitude ? latitude : 0,
                            longitude: longitude ? longitude : 0,
                            appCode: 'TDPOR',
                            ip: ip   // 👈 ahora va la IP real
                        };

                        return datacontext.auth.login(modelUserLogin, vm.user.languageId);
                    })
                    .then(
                        function (responseLogin) {
                            //get user data
                            datacontext.security.getUserInformation()
                                .then(
                                function (responseQuery) {
                                    var inactivityTime = responseQuery.configurationInactivityTime.value;
                                    common.localStorageService.set("EXPIRATION_INACTIVITY_TIME", inactivityTime);

                                    common.localStorageService.set('fromLoginWindow', true);
                                    common.localStorageService.set('canChangePassword', responseQuery.canChangePassword);
                                    common.localStorageService.set('UserId', responseQuery.userEntity.userId);
                                    common.localStorageService.set('Password', vm.user.password);
                                    if ((responseQuery.passExpired == true) || (common.localStorageService.get('changePassword'))) {
                                        common.localStorageService.set('changePassword', false);
                                        vm.UserId = responseQuery.userEntity.userId;
                                        datacontext.auth.logOut();

                                        common.localStorageService.set('Password', vm.user.password);
                                        $state.go('login');
                                        $('.formlogin').hide();
                                        if (responseQuery.canChangePassword) {
                                            $('#changePasswordForm').show();
                                            return;
                                        } else {
                                            $('#expirationDateForm').show();
                                            return;
                                        }
                                    }

                                    var responseUser = responseQuery.userEntity;
                                    var authData = common.localStorageService.get('authorizationData');
                                    common.localStorageService.set('authorizationData',
                                            Object.assign(authData,
                                    {
                                        token: authData.access_token,
                                        username: authData.username,
                                        fullname: responseUser.firstName + " " + responseUser.lastName,
                                        refreshToken: authData.refreshToken,
                                        useRefreshTokens: authData.useRefreshTokens,
                                        ModelRequester: {
                                            DefaultLanguageId: vm.user.languageId,
                                            CurrentGroupId: responseUser.currentGroupId,
                                            ApplicationId: responseUser.applicationId                                                
                                        },
                                        isOnlyPortalUser: responseUser.isOnlyPortalUser
                                    })
                                        );

                                    //api/security/getUserGroups
                                    var getUserGroupsQuery = responseQuery.userGroups;
                                    common.localStorageService.set('getUserGroupsQuery', getUserGroupsQuery);

                                    ///api/security/GetRolesByUser
                                    var GetRolesByUserQuery = responseQuery.userRole;
                                    common.localStorageService.set('GetRolesByUserQuery', GetRolesByUserQuery);

                                    //api/security/GetMenuBar
                                    var GetMenuBarQuery = responseQuery.menu;
                                    common.localStorageService.set('GetMenuBarQuery', GetMenuBarQuery);

                                    //validate depot
                                    var defaultUserYard = null;
                                    if (getUserGroupsQuery != null || getUserGroupsQuery != undefined)
                                        defaultUserYard = $(getUserGroupsQuery).filter(function (a, b) {
                                            return b.groupId == responseUser.defaultGroupId;
                                        })[0];

                                    if (defaultUserYard == null || defaultUserYard == undefined) {
                                        toastr.error(vm.messageNotAuthorized);
                                        datacontext.auth.logOut();
                                        HideLoader();
                                        return;
                                    }

                                    //Set default yard in equipment services
                                    //changeyard(defaultUserYard.code);
                                    //function changeyard(newYard) {
                                    var authData = common.localStorageService.get('authorizationData');
                                    var RolesByUserQuery = common.localStorageService.get('GetRolesByUserQuery');

                                    var moveYard;
                                    $.ajax({
                                        async: false,
                                        headers: {
                                            'Authorization': 'Bearer ' + authData.access_token,
                                            "ModelRequester": JSON.stringify(authData.ModelRequester)
                                        },
                                        url: common.config.basePaths.Base_Path_Resources + 'Appointment/changeBPyard?GroupCode=' + defaultUserYard.code + '&userName=' + encodeURIComponent(authData.username) + '&securityRole=' + RolesByUserQuery.code + '&fromLoginWindow=' + common.localStorageService.get('fromLoginWindow'),
                                        type: "GET",
                                        success: function (moveYardResult) {
                                            if (moveYardResult) {
                                                var moveYard = moveYardResult.Yard;
                                                common.localStorageService.set('GetBusinessPartnerUserRolesQuery', moveYardResult);

                                                var dataYards = common.localStorageService.get('getUserGroupsQuery');
                                                $(dataYards).each(function (i, j) {
                                                    if (j.code == moveYard.Code)
                                                        j.currentYard = "currentYard";
                                                    else
                                                        j.currentYard = "";
                                                });

                                                common.localStorageService.set('yardList', dataYards);
                                                authData.ModelRequester.CurrentYardId = moveYard.YardId;
                                                common.localStorageService.set('authorizationData', authData);

                                                geolocationService.destroy();

                                                var bussinesPartnerRoles = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
                                                if (responseQuery.isAdmin) {
                                                    vm.roleSelected = null;
                                                    redirectToDashboard();
                                                    return;
                                                }

                                                //Validate businesspartner role
                                                if (!bussinesPartnerRoles || (bussinesPartnerRoles && bussinesPartnerRoles.RoleTypeCodes == null) || (bussinesPartnerRoles && bussinesPartnerRoles.RoleTypeCodes.length == 0)) {
                                                    HideLoader();
                                                    toastr.error(vm.messageNotAuthorized);
                                                    datacontext.auth.logOut();
                                                    return;
                                                }

                                                vm.rolesInfo = bussinesPartnerRoles.RoleTypeCodes;
                                                if (bussinesPartnerRoles.RoleTypeCodes.length > 1)
                                                    showModalRol(bussinesPartnerRoles);
                                                else {
                                                    vm.roleSelected = bussinesPartnerRoles.RoleTypeCodes[0].Code;
                                                    redirectToDashboard();
                                                }
                                            }
                                        },
                                        error: function (err) {
                                            HideLoader();
                                            toastr.error(err.responseText);
                                        }
                                    });
                                    //}
                                },
                                function (err) {
                                    HideLoader();
                                    if (err.status && err.status.data && err.status.data.message)
                                        toastr.error(err.status.data.message);
                                    datacontext.auth.logOut();
                                });
                        },
                        function (err) {
                            HideLoader();
                            if (err.status && err.status.data && err.status.data.error_description) {
                                if(err.status.data.error == 'user_is_locked'){
                                    let objectArray = err.status.data.error_description.split("|");
                                    var userSessionId = objectArray[0];

                                    var messageError = objectArray[1];
                                    toastr.error(messageError);
                                    if (confirm($translate.instant("message.login.session_in_use_confirm"))) {
                                        datacontext.auth.forceCloseSession(userSessionId).then(
                                            function (respnse) {
                                                login();
                                            },
                                            function (err) {                                                    
                                            })                                            
                                    }
                                } else {
                                    toastr.error(err.status.data.error_description);
                                }                                
                            } else if (err.info) {
                                toastr.error(err.info);
                            }
                            datacontext.auth.logOut();
                        })
                    .catch(function (error) {
                        HideLoader();
                        console.error("Error obteniendo IP o en login:", error);
                        toastr.error("No se pudo iniciar sesión");
                    });
            }
            else {
                alert('La aplicación está optimizada para usar Google Chrome. ');
            }
        }

        vm.passwordInvalid = function passwordInvalid(password) {

            if (!password || password.length < 6) {
                return true;
            }

            var uppercase = new RegExp(/[A-Z]/);
            var lowercase = new RegExp(/[a-z]/);
            var numbers = new RegExp(/\d/);
            var symbols = new RegExp(/[-!$%^&*()_+|~=`{}\[\]:"; '<>?,.\/\\]/);

            var hasUppercase = uppercase.test(password);
            var hasLowercase = lowercase.test(password);
            var hasNumber = numbers.test(password);
            var hasSpecial = symbols.test(password);

            return [hasUppercase, hasLowercase, hasNumber, hasSpecial].filter(b => b).length < 3;
        }

        function backToLogin($event) {
            datacontext.auth.logOut();
            $rootScope.$broadcast(common.config.events.controllerToogleSplash, false);
            $event.preventDefault();
            $state.go('login');

            $('.formlogin').show();
            HideLoader();
            $('#expirationDateForm').hide();
        }

        function changePassword($event) {

            if (vm.passwordInvalid(vm.user.newPassword)) {
                toastr.warning('La contraseña no cumple con los requerimientos.');
                return false;
            }

            if (vm.user.newPassword == vm.user.newPasswordConfirm) {
                var password=common.localStorageService.get('Password');
                datacontext.security.changePassword(vm.UserId, password, vm.user.newPassword).then(function (responseQuery) {

                    if (responseQuery.isValidChange == true) {
                        toastr.info('Ingrese nuevamente con la nueva contraseña.');
                        ClearLoginScreen();

                        datacontext.auth.logOut();
                        $rootScope.$broadcast(common.config.events.controllerToogleSplash, false);
                        $event.preventDefault();
                        $state.go('login');

                        $('.formlogin').show();
                        $('#changePasswordForm').hide();
                    }

                }, function (err) {
                    datacontext.auth.logOut();
                    $rootScope.$broadcast(common.config.events.controllerToogleSplash, false);
                    $event.preventDefault();
                    $state.go('login');
                    if (err.status)
                        toastr.error(err.info);
                });
                common.localStorageService.set('Password','');
            }
            else {
                toastr.warning('Las contraseñas no coinciden, ingrese nuevamente. ');
            }

        }

        function recoverLanguageId(data, culture) {
            var languageId = null;
            angular.forEach(data, function (value) {
                if ((value.code).toUpperCase() == culture) {
                    languageId = value.id;
                    return false;
                }
            });
            return languageId;
        }

        function setFlagByLanguage(data) {
            angular.forEach(data, function (model) {
                switch (model.code) {
                    case 'EN-US':
                        //model.img = "../../../../assets/img/flags/flenus.png";
                        break;
                    case 'ES-ES':
                        //model.img = "../../../../assets/img/flags/fleses.png";
                        break;
                    default:
                        //model.img = "../../../../assets/img/flags/flenus.png";
                        break;
                }
            });
            return data;
        }

        function detectIE() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }



            // other browser
            return false;
        }

        function setPasswordRecoveryLink() {
            vm.passwordRecovery = common.config.basePaths.Password_Recovery_Path;
        }

        var dialog;
        function showModalRol() {
            dialog = ngDialog.open({
                template: "dashboardLoad",
                closeByDocument: false,
                closeByEscape: false,
                showClose: false,
                disableAnimation: true,
                scope: $scope
            });
        }

        function redirectToDashboard() {
            //update role
            var authData = common.localStorageService.get('authorizationData');
            authData.userRole = vm.roleSelected;

            common.localStorageService.set('authorizationData', authData);
            //create cookie for application
            common.createCookie("sessionTDP", 1);
            //redirect to dashboard
            $state.go('root');
        }

        function saveRole() {
            if (vm.roleSelected) {
                toastr.error("Debe seleccionar un Rol");
                return;
            }
            if (dialog)
                dialog.close();
            redirectToDashboard();
        }

        function HideLoader() {
            $("#divLoader").removeClass("loader");
            $("#divLoader").addClass("hideLoader");
        }

        function ShowLoader(e) {
            $("#divLoader").removeClass("hideLoader");
            $("#divLoader").addClass("loader");
        }

        function ClearLoginScreen() {
            vm.user.userName = '';
            vm.user.password = '';
            HideLoader();
        }

        $scope.checkIfEnterKeyWasPressed = function ($event) {
            if (vm.user.culture === '' || vm.user.userName === '' || vm.user.password === '') return;

            var keyCode = $event.which || $event.keyCode;

            if (keyCode === 13) {
                $timeout(function () {
                    angular.element('#btnLogin').triggerHandler('click');
                });
            }
        };

        function createAccount(){
            $state.go('createaccount');
        }
    }

})();